const state = {
    item: {},
    pageKey: 'inspection',
    pageName: 'Inspection',
    form: {
        pageName: 'Form',
        pageKey: 'inspection-form',
        pagePath: 'inspection/form',
        item: {}
    },
    point: {
        pageName: 'Point',
        pageKey: 'inspection-point',
        pagePath: 'inspection/point',
        item: {}
    },
    defect: {
        pageName: 'Defect',
        pageKey: 'inspection-defect',
        pagePath: 'inspection/defect',
        item: {}
    },
    defect_type: {
        pageName: 'Defect Type',
        pageKey: 'inspection-defect-type',
        pagePath: 'inspection/defect-type',
        item: {}
    },
}

const mutations = {
    SET_ITEM: (state, item) => {
        state.item = item
    },
    PATCH_ITEM: (state, data) => {
        state.item = Object.assign({}, state.item, data)
    },
    REMOVE_ITEM: (state) => {
        state.item = {}
    },

    SET_FORM_ITEM: (state, item) => {
        state.form.item = item
    },
    PATCH_FORM_ITEM: (state, data) => {
        state.form.item = Object.assign({}, state.form.item, data)
    },
    REMOVE_FORM_ITEM: (state) => {
        state.form.item = {}
    },

    SET_POINT_ITEM: (state, item) => {
        state.point.item = item
    },
    PATCH_POINT_ITEM: (state, data) => {
        state.point.item = Object.assign({}, state.point.item, data)
    },
    REMOVE_POINT_ITEM: (state) => {
        state.point.item = {}
    },

    SET_DEFECT_ITEM: (state, item) => {
        state.defect.item = item
    },
    PATCH_DEFECT_ITEM: (state, data) => {
        state.defect.item = Object.assign({}, state.defect.item, data)
    },
    REMOVE_DEFECT_ITEM: (state) => {
        state.defect.item = {}
    },

    SET_DEFECT_TYPE_ITEM: (state, item) => {
        state.defect_type.item = item
    },
    PATCH_DEFECT_TYPE_ITEM: (state, data) => {
        state.defect_type.item = Object.assign({}, state.defect_type.item, data)
    },
    REMOVE_DEFECT_TYPE_ITEM: (state) => {
        state.defect_type.item = {}
    },
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}